<dialog
  #dialogRef
  [ngClass]="{
    'tw:max-w-sm': maxWidth === 'sm',
    'tw:max-w-md': maxWidth === 'md',
    'tw:max-w-lg': maxWidth === 'lg',
    'tw:max-w-xl': maxWidth === 'xl',
    'tw:max-w-2xl': maxWidth === '2xl',
    'tw:max-w-225': maxWidth === '3xl',
    'tw:max-w-none': maxWidth === 'full',
    'tw:max-w-140': maxWidth === 'personal-data',
    'tw:px-5 tw:py-7': maxWidth !== 'personal-data',
  }"
  tabindex="-1"
  class="tw:border-0 tw:shadow-none tw:w-[calc(100%-2rem)] tw:max-h-[90vh] tw:fixed tw:overflow-hidden tw:z-1000 focus:tw:outline-none focus-visible:tw:outline-none"
>
  <button
    type="button"
    aria-label="Close dialog"
    (click)="_closeDialog()"
    [ngClass]="maxWidth === 'personal-data' ? 'tw:top-4 tw:right-4' : 'tw:top-3 tw:right-3'"
    class="tw:absolute tw:w-8 tw:h-8 tw:text-gray-200 hover:tw:text-gray-600 hover:tw:bg-gray-100 tw:text-2xl! tw:flex tw:items-center tw:justify-center tw:rounded-full tw:cursor-pointer tw:transition-colors tw:duration-150 focus:tw:outline-none focus:tw:ring-0 focus-visible:tw:ring-0"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
  <div class="dialog">
    <div
      [ngClass]="
        maxWidth === 'personal-data'
          ? 'tw:pt-15 tw:pb-10 tw:px-5 tw:sm:px-10'
          : 'tw:p-2 tw:lg:p-6'
      "
      class="content tw:flex tw:flex-col tw:flex-1 tw:min-h-0 tw:overflow-y-auto tw:scroll-smooth"
    >
      <header
        [ngClass]="maxWidth === 'personal-data' ? 'tw:mb-6' : ''"
        class="dialog-title"
      >
        <ng-content select="[dialog-title]"></ng-content>
      </header>
      <div class="dialog-content">
        <ng-content select="[dialog-content]"></ng-content>
      </div>
    </div>

    <footer
      [ngClass]="
        maxWidth === 'personal-data'
          ? 'tw:px-5 tw:sm:px-10 tw:py-5 tw:sm:py-6 tw:justify-between tw:border-t tw:border-creme'
          : 'tw:p-2 tw:lg:p-6 tw:justify-center'
      "
      class="dialog-actions tw:flex tw:gap-4 tw:shrink-0"
    >
      <ng-content select="[dialog-actions]"></ng-content>
    </footer>
  </div>
</dialog>
